import React from 'react';
import styles from '../InternshipForm.module.scss';

const DocIcon = () => (
  <svg
    className={styles.docIcon}
    xmlns="http://www.w3.org/2000/svg"
    width="40"
    height="40"
    viewBox="0 0 40 40"
    fill="none"
    aria-hidden="true"
  >
    <path
      d="M32.5 15.4717L22.5 4.22168H9.5C8.39543 4.22168 7.5 5.11711 7.5 6.22168V33.7781C7.5 34.8826 8.39543 35.7781 9.5 35.7781H20H30.5C31.6046 35.7781 32.5 34.8826 32.5 33.7781V15.4717ZM22.5 4.22168V13.4717C22.5 14.5762 23.3954 15.4717 24.5 15.4717H32.5"
      stroke="black"
    />
  </svg>
);

export default DocIcon;
